<template>
<div style="color:#6c757d !important;">
    <!-- ----------------------------------- -->
    <!-- navbar starts -->
    <vs-navbar v-model="indexActive" :color="colorx" text-color="rgba(255,255,255,.6)" active-text-color="rgba(255,255,255,1)" class="myNavbar">
        <div slot="title">
            <vs-navbar-title>Graphs Presentations</vs-navbar-title>
        </div>
    </vs-navbar>
    <!-- navbar ends -->
    <!-- ----------------------------------- -->
    <!-- container starts -->
    <div class="container mt-5">
        <div class="row">
            <div class="col-sm-12 p-0 print-scr">
                <span class="btn btn-primary float-right btn-sm print-btn" @click="printReport">
                    <i class="material-icons">print</i> Print
                </span>
                <vs-breadcrumb align="left" :items="
                  [
                   {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/Admin/adminDashboard'
                    },
                    {
                      title: 'Attendance Sheet',
                      url: '/#/',
                      active: true
                    }
                  ]"></vs-breadcrumb>
            </div>
        </div>
    </div>
    <div class="container container-bdr mt-2 mb-5">
        <!-- row starts -->
        <div class="row">
            <!-- ----------------------------------- -->
            <!-- col-md starts -->
            <div class="col-md-12 col-bdr-bottom">
                <p class="mt-2 mb-2">
                    <span>
                        <strong>Event Attendance Sheet</strong>
                    </span>
                    <span class="float-right">
                        <strong>Event Code :</strong> T327
                    </span>
                </p>
            </div>
            <!-- col-md ends -->
            <!-- ----------------------------------- -->
            <!-- col-md starts -->
            <div class="col-md-4 col-bdr-bottom">
                <img :src="basepath+'/unodc_logo.png'" class="mt-2 mb-2" alt="UNODC" width="200" />
            </div>
            <!-- col-md ends -->
            <!-- ----------------------------------- -->
            <!-- col-md starts -->
            <div class="col-md-4 col-bdr-bottom">
                <p class="mt-2 mb-2">
                    <span>
                        <strong>Plot # 5-11, Diplomatic Enclave, G-5, P.O.BOX 1051, Islamabad 44000, Pakistan</strong>
                    </span>
                </p>
            </div>
            <!-- col-md ends -->
            <!-- ----------------------------------- -->
            <!-- col-md starts -->
            <div class="col-md-4 col-bdr-bottom">
                <p class="mt-2 mb-2">
                    <span>
                        <strong>Country Office Pakistan</strong>
                    </span>
                </p>
            </div>
            <!-- col-md ends -->
            <!-- ----------------------------------- -->
            <!-- col-md starts -->
            <div class="col-md-12 col-bdr-bottom">
                <p class="mt-2 mb-2">
                    <span>
                        <strong>Event Title :</strong> Training on "Administrative Management, Managing Audit and Accounts"
                    </span>
                </p>
            </div>
            <!-- col-md ends -->
            <!-- ----------------------------------- -->
            <!-- col-md starts -->
            <div class="col-md-6 col-bdr-bottom">
                <p class="mt-2 mb-2">
                    <span>
                        <strong>Start Date :</strong> 10/30/2019
                    </span>
                </p>
            </div>
            <div class="col-md-6 col-bdr-bottom">
                <p class="mt-2 mb-2">
                    <span>
                        <strong>Finish Date :</strong> 12/30/2019
                    </span>
                </p>
            </div>
            <!-- col-md starts -->
            <div class="col-md-8 col-bdr-bottom">
                <p class="mt-2 mb-2">
                    <span>
                        <strong>Trainee(s) Name :</strong>
                    </span>
                </p>
            </div>
            <!-- col-md ends -->
            <!-- ----------------------------------- -->
            <!-- col-md starts -->
            <div class="col-md-4 col-bdr-bottom">
                <p class="mt-2 mb-2">
                    <span>
                        <strong>Total No of Participants: </strong>
                    </span>
                </p>
            </div>
            <!-- col-md ends -->
        </div>
        <!-- row ends -->
    </div>
    <!-- container ends -->
    <div class="container container-bdr mt-2 mb-5">
        <!-- row starts -->
        <div class="form-group form-row text-dark">
            <h6 class="sub-frm-title">Event Information</h6>
            <div class="row col-sm-12">
                <!-- <div class="">
          <form class="stacked"> -->
                <label for="email" class="col-sm-2">Email address:</label>
                <div class="col-sm-9">
                    <input type="email" class="form-control mb-2 mr-sm-2" placeholder="Enter email" id="email">
                </div>
                <!-- </form>
            </div> -->
            </div>
        </div>
        <!-- row ends -->

    </div>
    <!-- container ends -->
</div>
</template>

<script>
// import Chart from "chart.js";
import axios from 'axios';

export default {
    data: () => ({
        colorx: "#2196f3",
        basepath: process.env.VUE_APP_BASE_PATH,
    }),
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    },
    methods: {
        printReport: function () {
            window.print();
        }
    }
};
</script>

<style scoped>
.myNavbar {
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1), 0 5px 5px rgba(0, 0, 0, 0.1) !important;
}

.container-bdr {
    border-top: 2px solid #2196f36b;
    border-right: 2px solid #2196f36b;
    border-left: 2px solid #2196f36b;
    border-bottom: 2px solid #2196f36b;
}

.thead-primary {
    background-color: #2196f3
}

.col-bdr-bottom {
    border-bottom: 0.5px solid #2196f36b;
    border-left: 0.5px solid #2196f36b;
}

.nav-route-link {
    background: none !important;
    border-right: 0px !important;
}

.chart-container {
    position: relative;
    margin: auto;
    height: 340px;
    width: 340px;
}

.chart-container-sm {
    position: relative;
    margin: auto;
    height: 250px;
    width: 250px;
}

td.question {
    width: 50%;
    padding-right: 30px;
}

td.answer {
    width: 10%;
}

td.descriptive {
    width: 50%;
}

@media print {
    .print-btn {
        display: none;
    }
}
</style>
